export const hospitalRegisterActions = {
	REGISTER_HOSPITAL: {
		REQUEST: 'registration/registerHospitalRequest',
		SUCCESS: 'registration/registerHospitalSuccess',
		FAILURE: 'registration/registerHospitalFailure',
		RESET: 'registration/registerHospitalReset',
	},
};

// Action creators
export const registerHospitalRequest = () => ({
	type: hospitalRegisterActions.REGISTER_HOSPITAL.REQUEST,
});

export const registerHospitalSuccess = (data) => ({
	type: hospitalRegisterActions.REGISTER_HOSPITAL.SUCCESS,
	payload: data,
});

export const registerHospitalFailure = (error) => ({
	type: hospitalRegisterActions.REGISTER_HOSPITAL.FAILURE,
	payload:
		typeof error === 'string'
			? { message: error }
			: error?.message
				? { message: error.message }
				: { message: 'Unknown error' },
});

export const registerHospitalReset = () => ({
	type: hospitalRegisterActions.REGISTER_HOSPITAL.RESET,
});
